module.exports = __webpack_public_path__ + "img/pratices@2x.c529d2da.jpeg";